import React from 'react';
import { Button } from '@mantine/core';

const DownloadButton: React.FC<{
  label: string;
  href: string;
  leftSectionIcon?: React.ReactNode;
  rightSectionIcon?: React.ReactNode;
  props?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
}> = ({ label, href, leftSectionIcon, rightSectionIcon, props }) => {
  if (!href) {
    return (
      <Button
        variant="light"
        disabled
        leftSection={leftSectionIcon}
        rightSection={rightSectionIcon}
      >
        {label}
      </Button>
    );
  }

  return (
    <Button
      component="a"
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      variant="light"
      {...props}
      leftSection={leftSectionIcon}
      rightSection={rightSectionIcon}
    >
      {label}
    </Button>
  );
};

export default DownloadButton;
